import { render, staticRenderFns } from "./PageVerification.vue?vue&type=template&id=61354f11&scoped=true&"
import script from "./PageVerification.vue?vue&type=script&lang=js&"
export * from "./PageVerification.vue?vue&type=script&lang=js&"
import style0 from "./PageVerification.vue?vue&type=style&index=0&id=61354f11&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61354f11",
  null
  
)

export default component.exports